<ng-container *ngIf="addressesLoading">
	<div class="text-center p-4">
		<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
		<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_LOAD_MSG_ADDR'] }}</p>
	</div>
</ng-container>
<ng-container *ngIf="addressesError">
	<div class="text-center p-4">
		<i class="pi pi-exclamation-triangle text-danger" style="font-size: 2rem"></i>
		<p class="p-error mt-2">{{ translateServ.dictionary['MAINT_LOAD_FAILED_MSG_ADDR'] }}</p>
	</div>
</ng-container>
<ng-container *ngIf="!addressesLoading && !addressesError">

	<div class="flex justify-between items-center mb-3 px-2">
		<!-- Left: Create New button -->
		<button pButton type="button" icon="pi pi-plus"
			label="{{ translateServ.dictionary['CREATE_NEW'] || 'Create New' }}" class="p-button-sm p-button-primary"
			(click)="createNewRecord()"></button>

		<!-- Right: Global filter -->
		<span class="p-input-icon-left">
			<i class="pi pi-search"></i>
			<input type="text" pInputText [(ngModel)]="globalFilter" (input)="applyGlobalFilter()"
				placeholder="{{ translateServ.dictionary['SEARCH'] || 'Search' }}" class="p-inputtext-sm" />
		</span>
	</div>
	<div class="horizontal-scroll">
		<p-table #dt id="tab_addr" dataKey="RecID" [globalFilterFields]="globalFilterFields" [value]="addresses"
			*ngIf="addresses && addresses.length > 0; else noAddresses" styleClass="app-data-table app-data-table--paged app-data-table--editable p-datatable-sm p-datatable-striped"
			responsiveLayout="scroll" [paginator]="true" [totalRecords]="addresses.length"
			[rows]="getCurrentPageSize(0, addresses.length)" [rowsPerPageOptions]="setPaginator(addresses.length)"
			[showCurrentPageReport]="true"
			currentPageReportTemplate="{{ translateServ.dictionary['TAB_FOOTER_SHOWING'] }} {first} {{ translateServ.dictionary['TAB_FOOTER_TO'] }} {last} {{ translateServ.dictionary['TAB_FOOTER_OF'] }} {totalRecords} {{ translateServ.dictionary['MAINT_TABLE_ADDRS'] }}"
			[tableStyle]="{'min-width': '78rem', 'table-layout': 'auto'}" [paginatorDropdownAppendTo]="'body'"
			(onPage)="onRowsPerPageChange($event, 0, addresses.length)">
			<ng-template let-item pTemplate="paginatordropdownitem">
				{{ item.value === addresses.length ? 'All' : item.value }}
			</ng-template>
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="RecID">
						{{ translateServ.dictionary['MAINT_CS_TIT_ID'] || 'ID' }}
						<p-sortIcon field="RecID"></p-sortIcon>
					</th>
					<th pSortableColumn="AddressType">
						{{ translateServ.dictionary['MAINT_IN_TIT_ADDR_TYPE'] || 'Address Type'}}
						<p-sortIcon field="AddressType"></p-sortIcon>
					</th>
					<th pSortableColumn="Street">
						{{ translateServ.dictionary['MAINT_IN_TIT_STREET'] || 'Street'}}
						<p-sortIcon field="Street"></p-sortIcon>
					</th>
					<th pSortableColumn="House">
						{{ translateServ.dictionary['MAINT_IN_TIT_HOUSE'] || 'House'}}
						<p-sortIcon field="House"></p-sortIcon>
					</th>
					<th pSortableColumn="Appartment">
						{{ translateServ.dictionary['MAINT_IN_TIT_APARTMENT'] || 'Appartment'}}
						<p-sortIcon field="Appartment"></p-sortIcon>
					</th>
					<th pSortableColumn="Entrence">
						{{ translateServ.dictionary['MAINT_IN_TIT_ENTERENCE'] || 'Entrence'}}
						<p-sortIcon field="Entrence"></p-sortIcon>
					</th>
					<th pSortableColumn="City">
						{{ translateServ.dictionary['MAINT_IN_TIT_CITY'] || 'City'}}
						<p-sortIcon field="City"></p-sortIcon>
					</th>
					<th pSortableColumn="Country">
						{{ translateServ.dictionary['MAINT_IN_TIT_COUNTRY'] || 'Country'}}
						<p-sortIcon field="Country"></p-sortIcon>
					</th>
					<th pSortableColumn="PostalCode">
						{{ translateServ.dictionary['MAINT_IN_TIT_POSTAL'] || 'Postal Code'}}
						<p-sortIcon field="PostalCode"></p-sortIcon>
					</th>
					<th pSortableColumn="PostalBox">
						{{ translateServ.dictionary['MAINT_IN_TIT_POSTAL_BOX'] || 'Postal Box'}}
						<p-sortIcon field="PostalBox"></p-sortIcon>
					</th>
					<th pSortableColumn="IsActive">
						{{ translateServ.dictionary['STEP_TAB_TIT_ACT_STAT'] || 'Status' }}
						<p-sortIcon field="IsActive"></p-sortIcon>
					</th>
					<th pSortableColumn="IsApproved">
						{{ translateServ.dictionary['STEP_TAB_TIT_APPROVED'] || 'Approved' }}
						<p-sortIcon field="IsApproved"></p-sortIcon>
					</th>
					<th pSortableColumn="Descr">
						{{ translateServ.dictionary['STEP_TAB_TIT_DESC'] || 'Description' }}
						<p-sortIcon field="Descr"></p-sortIcon>
					</th>
					<th pSortableColumn="DateEntered">
						{{ translateServ.dictionary['MAINT_CS_TIT_DATE_ENTERED'] || 'Created On' }}
						<p-sortIcon field="DateEntered"></p-sortIcon>
					</th>
					<th pSortableColumn="DateUpdated">
						{{ translateServ.dictionary['MAINT_CS_TIT_DATE_UPDATED'] || 'Updated On' }}
						<p-sortIcon field="DateUpdated"></p-sortIcon>
					</th>
					<th>{{ translateServ.dictionary['MAINT_CS_TIT_ACTIONS'] || 'Actions' }}</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-addressItem>
				<tr>
					<td>{{ addressItem.RecID }}</td>
					<td>{{ addressItem.AddressType }}</td>
					<td>{{ addressItem.Street }}</td>
					<td>{{ addressItem.House }}</td>
					<td>{{ addressItem.Appartment }}</td>
					<td>{{ addressItem.Entrence }}</td>
					<td>{{ addressItem.City }}</td>
					<td>{{ addressItem.Country }}</td>
					<td>{{ addressItem.PostalCode }}</td>
					<td>{{ addressItem.PostalBox }}</td>
					<td>
						<p-tag [value]="addressItem.IsActive === 1 ? 'Active' : 'Inactive'"
							[severity]="getAddressSeverity(addressItem.IsActive)"
							(click)="toggleAddressStatus(addressItem, true)"></p-tag>
					</td>
					<td>
						<p-tag [value]="addressItem.IsApproved === 1 ? 'Approved' : 'Not Approved'"
							[severity]="getAddressSeverity(addressItem.IsApproved)"
							(click)="toggleAddressStatus(addressItem, false)"></p-tag>
					</td>
					<td>{{ addressItem.Descr || 'N/A' }}</td>
					<td>
						{{ addressItem.DateEntered ? (addressItem.DateEntered | date:'mediumDate') : 'N/A' }}
					</td>
					<td>
						{{ addressItem.DateUpdated ? (addressItem.DateUpdated | date:'mediumDate') : 'N/A' }}
					</td>
					<td>
						<div class="flex gap-2">
							<button pButton icon="pi pi-pencil" (click)="editAddress(addressItem)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']"
								tooltipPosition="top"></button>
							<button pButton icon="pi pi-trash" (click)="confirmDelete(addressItem)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']" tooltipPosition="top">
							</button>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
	<ng-template #noAddresses>
		<div class="text-center p-4">
			<i class="pi pi-map-marker text-400" style="font-size: 3rem"></i>
			<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_NO_DATA_MSG_ADDR'] }}</p>
		</div>
	</ng-template>
</ng-container>